import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";

export type QuotePublishingStatusFilter = "DRAFT" | "PUBLISHED";

const ALL_PUBLISHING_STATUS: QuotePublishingStatusFilter[] = [
  "DRAFT",
  "PUBLISHED",
];

export const PUBLISHING_STATUS_MAPPING: Record<
  QuotePublishingStatusFilter,
  boolean
> = {
  DRAFT: false,
  PUBLISHED: true,
};

export function useQuotePublishingStatus() {
  const { t } = useTranslate(["QuoteFilter"]);

  const publishingStatusLabels: Record<QuotePublishingStatusFilter, string> =
    useMemo(
      () => ({
        DRAFT: t("Draft"),
        PUBLISHED: t("Published"),
      }),
      [t]
    );

  const publishingStatusOptions = useMemo(
    () =>
      ALL_PUBLISHING_STATUS.map(status => ({
        value: status,
        label: publishingStatusLabels[status],
      })),
    [publishingStatusLabels]
  );

  return { publishingStatusLabels, publishingStatusOptions };
}
